import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import ConfiguracionCorreos from './configuracionCorreos/Correo';
import ConfiguracionCobros from './configuracionCobros/Cobro';
import Personalizacion from './Personalizacion';
import { AuthContext } from "../../context/authContext";
import './Configuraciones.css';

class ConfiguracionSistema extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);

    this.tabs = [
      {
        id: 'personalizacion',
        hash: '#personalizacion',
        title: 'Personalización',
        description: 'Logotipo, nombre y colores de la marca',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
          </svg>
        ),
        Componente: Personalizacion,
        access: [],
      },
      {
        id: 'cobros',
        hash: '#cobros',
        title: 'Cobros y Facturación',
        description: 'Impuestos, retención y factores operativos',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        ),
        Componente: ConfiguracionCobros,
        access: [],
      },
      {
        id: 'correos',
        hash: '#correos',
        title: 'Correos y Notificaciones',
        description: 'Alertas automáticas y copias CCO',
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        ),
        Componente: ConfiguracionCorreos,
        access: [],
      },
    ];

    const initialTab = this.getTabFromHash(props.location.hash);

    this.state = {
      activeTab: initialTab,
      availableTabs: this.tabs,
    };
  }

  componentDidMount() {
    const { hasAccess } = this.context;
    if (typeof hasAccess === 'function') {
      const filtered = this.tabs.filter(t => !t.access || t.access.length === 0 || hasAccess(t.access));
      this.setState({ availableTabs: filtered });
    }

    window.addEventListener('hashchange', this.handleHashChange);
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.handleHashChange);
  }

  getTabFromHash = (hash) => {
    const cleanHash = (hash || '').toLowerCase();
    if (cleanHash.includes('cobro')) return 'cobros';
    if (cleanHash.includes('correo')) return 'correos';
    return 'personalizacion';
  };

  handleHashChange = () => {
    const tab = this.getTabFromHash(window.location.hash);
    if (tab !== this.state.activeTab) {
      this.setState({ activeTab: tab });
    }
  };

  handleTabClick = (tab) => {
    this.setState({ activeTab: tab.id });
    if (window.location.hash !== tab.hash) {
      this.props.history.replace(`${this.props.location.pathname}${tab.hash}`);
    }
  };

  render() {
    const { activeTab, availableTabs } = this.state;
    const currentTab = availableTabs.find(t => t.id === activeTab) || availableTabs[0];
    const ActiveComponent = currentTab ? currentTab.Componente : null;

    return (
      <div className="system-config-container">
        {/* Header Section */}
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-2">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-orange-50 text-orange-700 border border-orange-200">
              <span className="w-1.5 h-1.5 rounded-full bg-orange-500 animate-pulse" />
              Ajustes Generales
            </span>
            <span className="text-xs text-gray-400">/ Sistema</span>
          </div>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900 tracking-tight">
            Configuración del Sistema
          </h1>
          <p className="text-sm text-gray-500 mt-1 max-w-3xl">
            Gestiona la identidad visual corporativa, los parámetros de facturación e impuestos, y las notificaciones automáticas por correo.
          </p>
        </div>

        {/* Modern Segmented Navigation Tabs (Non-collapsible) */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-8">
          {availableTabs.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => this.handleTabClick(tab)}
                className={`config-tab-btn flex items-start gap-3.5 p-4 rounded-xl border text-left cursor-pointer transition-all ${
                  isActive
                    ? 'bg-white border-orange-500 ring-2 ring-orange-500/10 shadow-sm'
                    : 'bg-white/70 hover:bg-white border-gray-200 hover:border-gray-300 shadow-2xs'
                }`}
              >
                <div
                  className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors ${
                    isActive
                      ? 'bg-orange-600 text-white shadow-2xs'
                      : 'bg-gray-100 text-gray-600'
                  }`}
                >
                  {tab.icon}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between">
                    <span
                      className={`text-sm font-bold truncate ${
                        isActive ? 'text-gray-900' : 'text-gray-700'
                      }`}
                    >
                      {tab.title}
                    </span>
                    {isActive && (
                      <span className="w-2 h-2 rounded-full bg-orange-600 flex-shrink-0" />
                    )}
                  </div>
                  <p className="text-xs text-gray-400 mt-0.5 line-clamp-1">
                    {tab.description}
                  </p>
                </div>
              </button>
            );
          })}
        </div>

        {/* Active Content Card */}
        <div className="bg-white rounded-2xl shadow-xs border border-gray-100 p-6 sm:p-8 md:p-10 transition-all">
          {ActiveComponent && <ActiveComponent {...this.props} />}
        </div>
      </div>
    );
  }
}

export default withRouter(ConfiguracionSistema);
